import EdOIGSAMCheck from './EdOIGSAMCheck';

export default EdOIGSAMCheck;